/* eslint-disable no-empty-pattern */
import React from 'react';
import { Wrapper } from './CustomMaterialTable.Styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
export var CustomMaterialTable = function (_a) {
    var rows = _a.rows, columns = _a.columns, style = _a.style;
    return (React.createElement(Wrapper, null,
        React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, { style: style },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null, columns === null || columns === void 0 ? void 0 : columns.map(function (col) { return (React.createElement(TableCell, { align: 'center' }, col.label)); }))),
                React.createElement(TableBody, null, rows === null || rows === void 0 ? void 0 : rows.map(function (row, i) { return (React.createElement(React.Fragment, null,
                    React.createElement(TableRow, { key: i }, columns === null || columns === void 0 ? void 0 : columns.map(function (col) { return (React.createElement(TableCell, { align: 'center' }, row[col.value])); })))); }))))));
};
CustomMaterialTable.defaultProps = {
    // bla: 'test',
    style: {
        width: 400
    }
};
//# sourceMappingURL=CustomMaterialTable.js.map